import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { nextTick, onMounted } from 'vue'
import { useStore } from 'vuex'
import { Mutations } from '@/store/enums/StoreEnums'
import { initializeComponents } from '@/core/plugins/keenthemes'
import AppOverlay from '@/components/feedback/AppOverlay.vue'
import ToastContainer from '@/components/feedback/ToastContainer.vue'
import StagingBanner from '@/components/StagingBanner.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore()

onMounted(() => {
  // Override layout config using saved data from localStorage.
  // Remove to use config only from static config (@/core/config/DefaultLayoutConfig.ts).
  store.commit(Mutations.OVERRIDE_LAYOUT_CONFIG)

  void nextTick(() => {
    initializeComponents()
  })
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(StagingBanner),
    _createVNode(_component_router_view),
    _createVNode(AppOverlay),
    _createVNode(ToastContainer)
  ], 64))
}
}

})